<template>
    <div v-if="sapProfile==true" style="overflow-x:auto !important">
        <div class="my_fontSize_1Point5 my_color_00338e my_fontWeight_600 ZAfont_family">{{$t('3027')}}</div>
        <div v-if="elevatorMotor_Machine_Manual != null">
            <!--v-if="((elevatorMotor_Machine_Selection_Shown==false)&&(elevatorMotor_Machine_Selected==true))"-->
            <ul style="list-style:none; margin:0; padding:0">
                <li style="display:block; border: 2px solid blue;">
                    <div class="my_div_width1500" style="width:100%">
                        <div style="border: 1px solid #ced2d8; display:grid;">
                            <div style="display:grid; grid-template-columns:auto auto auto auto auto auto auto; grid-template-rows:auto auto auto;  padding:9px; overflow: auto">
                                <div style="align-self:center; grid-column: 1 / span 7">
                                    <div class="my_fontWeight_600 my_fontSize_1Point1 ZAfont_family">
                                        <!--:style='{color:customizedColor(selected_elevatorMotor_Machine.customized)}'-->
                                        <span>{{elevatorMotor_Machine_Manual.elevatorMotorMachineManual.typeDesignation}}</span>
                                        <span class="my_fontWeight_600" v-if="elevatorMotor_Machine_Manual.elevatorMotorMachineManual.autoP==1" style="padding-left:15px; color:royalblue">A</span>
                                        <!--<span v-if="selected_elevatorMotor_Machine.customized===true"> ({{selected_elevatorMotor_Machine.customerName}})</span>-->
                                    </div>
                                </div>
                                <div class="width1500" style="grid-column: 1 / span 1; grid-row: 2 / span 2">
                                    <Images :imageFilePath="elevatorMotor_Machine_Manual.elevatorMotorMachineManual.imagePath" :maxImageHeight="90" :maxImageWidth="150"></Images>
                                </div>
                                <div class="my_div_minWidth_100 my_div_maginleft_5">
                                    <div class="my_fontSize_1Point4"><span class="my_font-weight_600">{{elevatorMotor_Machine_Manual.tractionSheaveManual.diameter}} <!--|--> <!--{{selected_elevatorMotor_Machine.elevatorMotor_TractionSheave.grooveDistance}}--></span> mm</div>
                                    <div class="my_table_parameters_infoText">{{$t('1301')}}</div>
                                </div>
                                <div class="my_div_minWidth_100 my_div_maginleft_5">
                                    <div class="my_fontSize_1Point4"><span class="my_font-weight_600">{{elevatorMotor_Machine_Manual.tractionSheaveManual.width}}</span> mm</div>
                                    <div class="my_table_parameters_infoText">{{$t('1182')}}</div>
                                </div>
                                <div class="my_div_minWidth_100 my_div_maginleft_5">
                                    <div class="my_fontSize_1Point4"><span class="my_font-weight_600">{{elevatorMotor_Machine_Manual.tractionSheaveManual.grooveDistance}}</span> mm</div>
                                    <div class="my_table_parameters_infoText">{{$t('1294')}}</div>
                                </div>
                                <div class="my_div_minWidth_100 my_div_maginleft_5">
                                    <div class="my_fontSize_1Point4">
                                        <span class="my_font-weight_600">{{elevatorMotor_Machine_Manual.tractionSheaveManual.profile.useTextKey?$t(elevatorMotor_Machine_Manual.tractionSheaveManual.profile.textKey):elevatorMotor_Machine_Manual.tractionSheaveManual.profile.textUI}}</span>
                                    </div>
                                    <div class="my_table_parameters_infoText">{{$t('1123')}}</div>
                                </div>
                                <div class="my_div_minWidth_100 my_div_maginleft_5">
                                    <div class="my_fontSize_1Point4"><span class="my_font-weight_600">{{elevatorMotor_Machine_Manual.tractionSheaveManual.numberOfGrooves}}</span> mm</div>
                                    <div class="my_table_parameters_infoText">{{$t('165')}}</div>
                                </div>
                                <div class="my_div_minWidth_100 my_div_maginleft_5">
                                    <div class="my_fontSize_1Point4"><span class="my_font-weight_600">{{elevatorMotor_Machine_Manual.tractionSheaveManual.ropeDiameter}}</span> mm</div>
                                    <div class="my_table_parameters_infoText">{{$t('1067')}}</div>
                                </div>
                                <div class="my_div_minWidth_100 my_div_maginleft_5">
                                    <div class="my_fontSize_1Point4"><span class="my_font-weight_600">{{elevatorMotor_Machine_Manual.elevatorMotorMachineManual.ratedSpeed}}</span> rpm</div>
                                    <div class="my_table_parameters_infoText">{{$t('1091')}}</div>
                                </div>
                                <div class="my_div_minWidth_100 my_div_maginleft_5">
                                    <div class="my_fontSize_1Point4"><span class="my_font-weight_600">{{elevatorMotor_Machine_Manual.elevatorMotorMachineManual.voltage}}</span> V</div>
                                    <div class="my_table_parameters_infoText">{{$t('3073')}}</div>
                                </div>
                                <!--<div class="my_div_minWidth_100">
                                <div class="my_fontSize_1Point4"><span class="my_font-weight_600">PTC-->
                                <!--{{elevatorMotor_Machine_Manual.elevatorMotorMachineManual.nominalTorque}}-->
                                <!--</span></div>
                                    <div class="my_table_parameters_infoText">{{$t('3067')}}</div>
                                </div>-->
                                <div class="my_div_minWidth_100 my_div_maginleft_5">
                                    <div class="my_fontSize_1Point4">
                                        <span class="my_font-weight_600">{{elevatorMotor_Machine_Manual.elevatorMotorMachineManual.certification.useTextKey?$t(elevatorMotor_Machine_Manual.elevatorMotorMachineManual.certification.textKey):elevatorMotor_Machine_Manual.elevatorMotorMachineManual.certification.textUI}}</span>
                                    </div>
                                    <div class="my_table_parameters_infoText">{{$t('3455')}}</div>
                                </div>
                                <div class="my_div_minWidth_100 my_div_maginleft_5">
                                    <div class="my_fontSize_1Point4">
                                        <span class="my_font-weight_600">{{elevatorMotor_Machine_Manual.elevatorMotorMachineManual.forcedVentilation.useTextKey?$t(elevatorMotor_Machine_Manual.elevatorMotorMachineManual.forcedVentilation.textKey):elevatorMotor_Machine_Manual.elevatorMotorMachineManual.forcedVentilation.textUI}}</span>
                                    </div>
                                    <div class="my_table_parameters_infoText">{{$t('298')}}</div>
                                </div>
                                <div class="my_div_minWidth_100 my_div_maginleft_5">
                                    <div class="my_fontSize_1Point4">
                                        <span class="my_font-weight_600">{{elevatorMotor_Machine_Manual.elevatorMotorMachineManual.temperatureMonitoring.useTextKey?$t(elevatorMotor_Machine_Manual.elevatorMotorMachineManual.temperatureMonitoring.textKey):elevatorMotor_Machine_Manual.elevatorMotorMachineManual.temperatureMonitoring.textUI}}</span>
                                    </div>
                                    <div class="my_table_parameters_infoText">{{$t('3067')}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <div v-if="elevatorMotor_Brake_Selection.length>0" style="align-items:center; margin-top:25px">
            <div>
                <div class="my_fontSize_1Point5 my_color_00338e my_fontWeight_600 ZAfont_family">{{$t('3260')}}</div>
            </div>
            <div style="grid-column:2 / span 1">
                <div>
                    <div>
                        <div class="my_fontSize_1Point2 ZAfont_family">
                            <span>{{$t('3073')}}</span>
                            <span v-if="elevatorMotor_Brake_Voltage_Selection.length==1">: </span>
                            <span v-if="selected_elevatorMotor_Brake_Voltage.nominalVoltage == selected_elevatorMotor_Brake_Voltage.switchOnVoltage" class="my_font-weight_600"> {{selected_elevatorMotor_Brake_Voltage.nominalVoltage}}</span>
                            <span v-if="selected_elevatorMotor_Brake_Voltage.nominalVoltage != selected_elevatorMotor_Brake_Voltage.switchOnVoltage && selected_elevatorMotor_Brake_Voltage.nominalVoltage > 0" class="my_font-weight_600">{{selected_elevatorMotor_Brake_Voltage.switchOnVoltage}} / {{selected_elevatorMotor_Brake_Voltage.nominalVoltage}}</span>
                            <span v-if="selected_elevatorMotor_Brake_Voltage.nominalVoltage != selected_elevatorMotor_Brake_Voltage.switchOnVoltage && selected_elevatorMotor_Brake_Voltage.nominalVoltage <= 0" class="my_font-weight_600">{{selected_elevatorMotor_Brake_Voltage.switchOnVoltage}}</span>
                            <span> V</span>
                        </div>
                        <div v-if="elevatorMotor_Brake_Voltage_Selection.length>1">
                            <ul class="my_elevatorMotor_Brake_Voltage_Selection my_fontSize_1Point1">
                                <li style="cursor: pointer" v-for="elevatorMotor_Brake_Voltage in elevatorMotor_Brake_Voltage_Selection" @click="change_Selected_at_elevatorMotor_Brake_Voltage_Selection(elevatorMotor_Brake_Voltage)" v-bind:class="{active: elevatorMotor_Brake_Voltage.selected}"><span v-if="elevatorMotor_Brake_Voltage.nominalVoltage == elevatorMotor_Brake_Voltage.switchOnVoltage" class="my_fontWeight_600">{{elevatorMotor_Brake_Voltage.nominalVoltage}}</span><span v-if="elevatorMotor_Brake_Voltage.nominalVoltage != elevatorMotor_Brake_Voltage.switchOnVoltage && elevatorMotor_Brake_Voltage.nominalVoltage > 0" class="my_fontWeight_600">{{elevatorMotor_Brake_Voltage.switchOnVoltage}} / {{elevatorMotor_Brake_Voltage.nominalVoltage}}</span><span v-if="elevatorMotor_Brake_Voltage.nominalVoltage != elevatorMotor_Brake_Voltage.switchOnVoltage && elevatorMotor_Brake_Voltage.nominalVoltage <= 0" class="my_fontWeight_600">{{elevatorMotor_Brake_Voltage.switchOnVoltage}}</span> V</li>
                            </ul>
                        </div>
                    </div>
                    <div style="margin-top:10px">
                        <div class="my_fontSize_1Point2 ZAfont_family">
                            <span>{{$t('3045')}} :</span>
                            <span v-if="elevatorMotor_Brake_MechanicalRelease_Selection.length==1">
                                <span class="my_font-weight_600" v-if="selected_elevatorMotor_Brake_MechanicalRelease!=null">
                                    <span> {{selected_elevatorMotor_Brake_MechanicalRelease.useTextKey?$t(selected_elevatorMotor_Brake_MechanicalRelease.textKey):selected_elevatorMotor_Brake_MechanicalRelease.textUI}}</span>
                                </span>
                            </span>
                        </div>
                        <div v-if="elevatorMotor_Brake_MechanicalRelease_Selection.length>1">
                            <ul class="my_elevatorMotor_Brake_MechanicalRelease_Selection my_fontSize_1Point1 my_fontWeight_600">
                                <li style="cursor: pointer" v-for="elevatorMotor_Brake_MechanicalRelease in elevatorMotor_Brake_MechanicalRelease_Selection" @click="change_Selected_at_elevatorMotor_Brake_MechanicalRelease_Selection(elevatorMotor_Brake_MechanicalRelease)" v-bind:class="{active: elevatorMotor_Brake_MechanicalRelease.selected, disabled: elevatorMotor_Brake_MechanicalRelease.disabled}">
                                    <span>{{elevatorMotor_Brake_MechanicalRelease.useTextKey?$t(elevatorMotor_Brake_MechanicalRelease.textKey):elevatorMotor_Brake_MechanicalRelease.textUI}}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div style="margin-top:10px; margin-bottom:10px">
                        <div class="my_fontSize_1Point2 ZAfont_family">
                            <span>{{$t('208')}}</span>
                            <span v-if="elevatorMotor_Brake_ReleaseMonitoring_Selection.length==1">
                                : <span class="my_font-weight_600" v-if="selected_elevatorMotor_Brake_ReleaseMonitoring!=null">
                                    <span> {{selected_elevatorMotor_Brake_ReleaseMonitoring.useTextKey?$t(selected_elevatorMotor_Brake_ReleaseMonitoring.textKey):selected_elevatorMotor_Brake_ReleaseMonitoring.textUI}}</span>
                                </span>
                            </span>
                        </div>
                        <div v-if="elevatorMotor_Brake_ReleaseMonitoring_Selection.length>1">
                            <ul class="my_elevatorMotor_Brake_ReleaseMonitoring_Selection my_fontSize_1Point1 my_fontWeight_600">
                                <li style="cursor: pointer" v-for="elevatorMotor_Brake_ReleaseMonitoring in elevatorMotor_Brake_ReleaseMonitoring_Selection" @click="change_Selected_at_elevatorMotor_Brake_ReleaseMonitoring_Selection(elevatorMotor_Brake_ReleaseMonitoring)" v-bind:class="{active: elevatorMotor_Brake_ReleaseMonitoring.selected, disabled: elevatorMotor_Brake_ReleaseMonitoring.disabled}">
                                    <span>{{elevatorMotor_Brake_ReleaseMonitoring.useTextKey?$t(elevatorMotor_Brake_ReleaseMonitoring.textKey):elevatorMotor_Brake_ReleaseMonitoring.textUI}}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div style="margin-bottom:10px" v-if="bowdenwireDeliverSelection.length>0">
                        <div class="my_fontSize_1Point2 ZAfont_family">
                            <span>{{$t('3442')}}</span>
                            <span v-if="bowdenwireDeliverSelection.length==1">: <span class="my_font-weight_600" v-if="selectedBowdenwireDeliver!=null"> {{selectedBowdenwireDeliver.text.textKey!=null?$t(selectedBowdenwireDeliver.text.textKey):selectedBowdenwireDeliver.text.textUI}}</span></span>
                        </div>
                        <div v-if="bowdenwireDeliverSelection.length>1">
                            <ul class="my_elevatorMotor_Brake_Connection_Selection my_fontSize_1Point1">
                                <li style="cursor: pointer" v-for="bowdenwireDeliver in bowdenwireDeliverSelection" @click="change_Selected_atElementOf_bowdenwireDeliver(bowdenwireDeliver)" v-bind:class="{active: bowdenwireDeliver.selected}">
                                    <span class="my_fontWeight_600">{{bowdenwireDeliver.text.textKey!=null?$t(bowdenwireDeliver.text.textKey):bowdenwireDeliver.text.textUI}}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div style="margin-bottom:10px" v-if="bowdenwireDetailsSelection.length>0 && showBowdenwireDetails===true">
                        <div class="my_fontSize_1Point2 ZAfont_family">
                            <span>{{$t('3443')}}</span>
                            <span v-if="bowdenwireDetailsSelection.length==1">: <span class="my_font-weight_600" v-if="selectedBowdenwireDetails!=null"> {{selectedBowdenwireDetails.length}}</span></span>
                        </div>
                        <div v-if="bowdenwireDetailsSelection.length>1">
                            <ul class="my_elevatorMotor_Brake_Connection_Selection my_fontSize_1Point1">
                                <li style="cursor: pointer" v-for="bowdenwireDetails in bowdenwireDetailsSelection" @click="change_Selected_atElementOf_bowdenwireDetails(bowdenwireDetails)" v-bind:class="{active: bowdenwireDetails.selected}">
                                    <span class="my_fontWeight_600">{{bowdenwireDetails.length}}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div style="margin-bottom:10px" v-if="brakeConnectionSelection.length>0">
                        <div class="my_fontSize_1Point2 ZAfont_family">
                            <span>{{$t('3441')}}</span>
                            <span v-if="brakeConnectionSelection.length==1">: <span class="my_font-weight_600" v-if="selectedBrakeConnection!=null"> {{selectedBrakeConnection.textKey!=null?$t(selectedBrakeConnection.textKey):selectedBrakeConnection.textUI}}<span v-if="selectedBrakeConnection.additionalText!=null" class="my_font-weight_600 my_color_00338e"> {{selectedBrakeConnection.additionalText}}</span></span></span>
                        </div>
                        <div v-if="brakeConnectionSelection.length>1">
                            <ul class="my_elevatorMotor_Brake_Connection_Selection my_fontSize_1Point1">
                                <li style="cursor: pointer" v-for="brakeConnection in brakeConnectionSelection" @click="change_Selected_atElementOf_brakeConnection(brakeConnection)" v-bind:class="{active: brakeConnection.selected}">
                                    <span class="my_fontWeight_600">{{brakeConnection.textKey!=null?$t(brakeConnection.textKey):brakeConnection.textUI}}</span>
                                    <span v-if="brakeConnection.additionalText!=null" class="my_font-weight_600 my_color_00338e"> {{brakeConnection.additionalText}}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="rotatedBrakeRelease_Selection.length>0" style="align-items:center; margin-top:15px">
            <div>
                <div class="my_fontSize_1Point5 my_color_00338e ZAfont_family">
                    <span class="my_fontSize_1Point5 my_color_00338e my_fontWeight_600 ZAfont_family">{{$t('3714')}}</span>
                    <span v-if="rotatedBrakeRelease_Selection.length==1">: <span> {{selected_rotatedBrakeRelease.value}} &deg;</span></span>
                </div>
            </div>
            <div style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                <div>
                    <div v-if="rotatedBrakeRelease_Selection.length>1" style="grid-column:2 / span 1">
                        <ul class="my_elevatorMotor_Encoder my_fontSize_1Point1 my_fontWeight_600">
                            <li style="cursor: pointer" v-for="rotatedBrakeRelease in rotatedBrakeRelease_Selection" @click="change_Selected_atElementOf_rotatedBrakeRelease(rotatedBrakeRelease)" v-bind:class="{active: rotatedBrakeRelease.selected}">{{rotatedBrakeRelease.value}} &deg;</li>
                        </ul>
                    </div>
                </div>
                <div>
                    <div style="display: flex; justify-content: center; align-items: center ">
                        <img src="../../../../public/img/ProductImages/RotatedBrake.png" style="width: 250px" />
                    </div>
                </div>
            </div>
        </div>
        <div v-if="elevatorMotor_Encoder_Selection.length>0" style="align-items:center; margin-top:15px">
            <div>
                <div class="my_fontSize_1Point5 my_color_00338e ZAfont_family">
                    <span class="my_fontSize_1Point5 my_color_00338e my_fontWeight_600 ZAfont_family">{{$t('3075')}}</span>
                    <span v-if="elevatorMotor_Encoder_Selection.length==1">
                        <span>: </span>
                        <span> {{selected_elevatorMotor_Encoder.elevatorMotor_Encoder.typeDesignation}}</span>
                        <span v-if="selected_elevatorMotor_Encoder.elevatorMotor_Encoder.connectedCableLength!=null&&selected_elevatorMotor_Encoder.elevatorMotor_Encoder.connectedCableLength>0"> | {{selected_elevatorMotor_Encoder.elevatorMotor_Encoder.connectedCableLength}} m</span>
                    </span>
                </div>
            </div>
            <div v-if="elevatorMotor_Encoder_Selection.length>1" style="grid-column:2 / span 1">
                <ul class="my_elevatorMotor_Encoder my_fontSize_1Point1 my_fontWeight_600">
                    <li style="cursor: pointer" v-for="elevatorMotor_Encoder in elevatorMotor_Encoder_Selection" @click="change_Selected_at_elevatorMotor_Encoder_Selection(elevatorMotor_Encoder)" v-bind:class="{active: elevatorMotor_Encoder.selected}">
                        <span>{{elevatorMotor_Encoder.elevatorMotor_Encoder.typeDesignation}}</span>
                        <span v-if="elevatorMotor_Encoder.elevatorMotor_Encoder.connectedCableLength!=null&&elevatorMotor_Encoder.elevatorMotor_Encoder.connectedCableLength>0"> | {{elevatorMotor_Encoder.elevatorMotor_Encoder.connectedCableLength}} m</span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="my_btn_nextConfigurationStep_position">
            <button @click="furtherToManualHome()" class="btn my_btn_nextConfigurationStep" style="margin-right: 5px">{{$t('3366')}}</button>
            <!--<button @click="furtherToInput()" class="btn my_btn_nextConfigurationStep" style="margin-right: 5px">{{$t('1018')}}</button>-->
            <button @click="furtherToCables()" class="btn my_btn_nextConfigurationStep">{{$t('1023')}}</button>
        </div>
    </div>
</template>


<script>
    import router from '../../../router';
    import LoaderIcon from '../../loader/LoaderIcon';
    import InvalidInputs from '../../configuration/InvalidInputs'
    import InvalidityReasons from '../../dataValidation/InvalidityReasons';
    import Images from '../../configuration/Images';
    import { driveTechnologiesManual } from '../../../store/driveTechnologiesManual.module';

    export default {
        name: 'DriveTechnologiesManual',

        components: {
            LoaderIcon,
            InvalidInputs,
            InvalidityReasons,
            Images,
        },

        created() {
            router.push('/');
            if (this.$store.state.manualHome.kid == null) {
                router.push('../manualStep/ManualHome');
            }
            if (this.$store.state.inputsManual.inputData != null && this.$store.state.inputsManual.inputData.mTYP == null) {
                router.push({ params: { slug: 'inputsManual' } })
            }
            else {
                this.$store.commit('configurations/MANU_configuration', true);
                this.$store.commit('configurations/change_elevatorMotor_Manual_storeMutation', true);
                this.$store.dispatch('driveTechnologiesManual/check_toDos_at_driveTechnologiesManual_storeAction');
            }
        },
        computed: {
            sapProfile: {
                get() {
                    return this.$store.state.configurations.sap;
                },
            },
            elevatorMotor_Machine_Manual: {
                get() {
                    if (this.$store.state.driveTechnologiesManual.elevatorMotor_Machine_Manual != null && this.$store.state.driveTechnologiesManual.elevatorMotor_Machine_Manual.hasOwnProperty('elevatorMotorMachineManual')) {
                        return this.$store.state.driveTechnologiesManual.elevatorMotor_Machine_Manual;
                    }
                    else {
                        return null;
                    }
                }
            },
            // elevatorMotor_Brake
            elevatorMotor_Brake_Selection: {
                get() {
                    if ((this.$store.state.driveTechnologiesManual.elevatorMotor_Brake_Manual_Data.hasOwnProperty('elevatorMotor_Brake_Selection')) && (Array.isArray(this.$store.state.driveTechnologiesManual.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection))) {
                        return this.$store.state.driveTechnologiesManual.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection;
                    }
                    else {
                        return [];
                    }
                },
            },
            elevatorMotor_Brake_Selected: {
                get() {
                    if ((this.$store.state.driveTechnologiesManual.elevatorMotor_Brake_Manual_Data.hasOwnProperty('elevatorMotor_Brake_Selection')) && (Array.isArray(this.$store.state.driveTechnologiesManual.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection))) {
                        return this.$store.state.driveTechnologiesManual.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection.some(i => i.selected == true)
                    }
                },
            },
            selected_elevatorMotor_Brake: {
                get() {
                    return this.$store.state.driveTechnologiesManual.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Selection.find(i => i.selected == true);
                }
            },
            elevatorMotor_Brake_Voltage_Selection: {
                get() {
                    return this.$store.state.driveTechnologiesManual.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Voltage_Selection;
                }
            },
            selected_elevatorMotor_Brake_Voltage: {
                get() {
                    return this.$store.state.driveTechnologiesManual.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_Voltage_Selection.find(i => i.selected == true);
                },
            },
            elevatorMotor_Brake_MechanicalRelease_Selection: {
                get() {
                    return this.$store.state.driveTechnologiesManual.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_MechanicalRelease_Selection;
                }
            },
            selected_elevatorMotor_Brake_MechanicalRelease: {
                get() {
                    return this.$store.state.driveTechnologiesManual.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_MechanicalRelease_Selection.find(i => i.selected == true);
                },
            },
            elevatorMotor_Brake_ReleaseMonitoring_Selection: {
                get() {
                    return this.$store.state.driveTechnologiesManual.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_ReleaseMonitoring_Selection;
                }
            },
            selected_elevatorMotor_Brake_ReleaseMonitoring: {
                get() {
                    return this.$store.state.driveTechnologiesManual.elevatorMotor_Brake_Manual_Data.elevatorMotor_Brake_ReleaseMonitoring_Selection.find(i => i.selected == true);
                },
            },
            bowdenwireDeliverSelection: {
                get() {
                    if (this.$store.state.driveTechnologiesManual.bowdenwireDeliverSelection != null && Array.isArray(this.$store.state.driveTechnologiesManual.bowdenwireDeliverSelection)) {
                        return this.$store.state.driveTechnologiesManual.bowdenwireDeliverSelection;
                    }
                    return [];
                },
            },
            selectedBowdenwireDeliver: {
                get() {
                    if (this.$store.state.driveTechnologiesManual.bowdenwireDeliverSelection != null && Array.isArray(this.$store.state.driveTechnologiesManual.bowdenwireDeliverSelection)) {
                        const firstIndex_whichMeetConditions = this.$store.state.driveTechnologiesManual.bowdenwireDeliverSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            return this.$store.state.driveTechnologiesManual.bowdenwireDeliverSelection[firstIndex_whichMeetConditions];
                        }
                    }
                    return null;
                },
                set(value) {
                    this.change_Selected_atElementOf_bowdenwireDeliver(value);
                }
            },
            showBowdenwireDetails:
            {
                get() {
                    if (this.$store.state.driveTechnologiesManual.bowdenwireDeliverSelection != null && Array.isArray(this.$store.state.driveTechnologiesManual.bowdenwireDeliverSelection)) {
                        const firstIndex_whichMeetConditions = this.$store.state.driveTechnologiesManual.bowdenwireDeliverSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            return this.$store.state.driveTechnologiesManual.bowdenwireDeliverSelection[firstIndex_whichMeetConditions].showDetails;
                        }
                    }
                    return false;
                },
            },
            bowdenwireDetailsSelection: {
                get() {
                    if (this.$store.state.driveTechnologiesManual.bowdenwireDetailsSelection != null && Array.isArray(this.$store.state.driveTechnologiesManual.bowdenwireDetailsSelection)) {
                        return this.$store.state.driveTechnologiesManual.bowdenwireDetailsSelection;
                    }
                    return [];
                },
            },
            selectedBowdenwireDetails: {
                get() {
                    if (this.$store.state.driveTechnologiesManual.bowdenwireDetailsSelection != null && Array.isArray(this.$store.state.driveTechnologiesManual.bowdenwireDetailsSelection)) {
                        const firstIndex_whichMeetConditions = this.$store.state.driveTechnologiesManual.bowdenwireDetailsSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            return this.$store.state.driveTechnologiesManual.bowdenwireDetailsSelection[firstIndex_whichMeetConditions];
                        }
                    }
                    return null;
                },
                set(value) {
                    this.change_Selected_atElementOf_bowdenwireDetails(value);
                }
            },
            brakeConnectionSelection: {
                get() {
                    if (this.$store.state.driveTechnologiesManual.brakeConnectionSelection != null && Array.isArray(this.$store.state.driveTechnologiesManual.brakeConnectionSelection)) {
                        return this.$store.state.driveTechnologiesManual.brakeConnectionSelection;
                    }
                    return [];
                },
            },
            selectedBrakeConnection: {
                get() {
                    if (this.$store.state.driveTechnologiesManual.brakeConnectionSelection != null && Array.isArray(this.$store.state.driveTechnologiesManual.brakeConnectionSelection)) {
                        const firstIndex_whichMeetConditions = this.$store.state.driveTechnologiesManual.brakeConnectionSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            return this.$store.state.driveTechnologiesManual.brakeConnectionSelection[firstIndex_whichMeetConditions];
                        }
                    }
                    return null;
                },
                set(value) {
                    this.change_Selected_atElementOf_brakeConnection(value);
                }
            },
            rotatedBrakeRelease_Selection: {
                get() {
                    if (this.$store.state.driveTechnologiesManual.rotatedBrakeReleaseSelection != null && Array.isArray(this.$store.state.driveTechnologiesManual.rotatedBrakeReleaseSelection)) {
                        return this.$store.state.driveTechnologiesManual.rotatedBrakeReleaseSelection;
                    }
                    return [];
                }
            },
            selected_rotatedBrakeRelease: {
                get() {
                    if (this.$store.state.driveTechnologiesManual.rotatedBrakeReleaseSelection != null && Array.isArray(this.$store.state.driveTechnologiesManual.rotatedBrakeReleaseSelection)) {
                        const firstIndex_whichMeetConditions = this.$store.state.driveTechnologiesManual.rotatedBrakeReleaseSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            return this.$store.state.driveTechnologiesManual.rotatedBrakeReleaseSelection[firstIndex_whichMeetConditions];
                        }
                    }
                    return null;
                },
                set(value) {
                    this.change_Selected_atElementOf_rotatedBrakeRelease(value);
                }
            },
            // elevatorMotor_Encoder
            elevatorMotor_Encoder_Selection: {
                get() {
                    if ((this.$store.state.driveTechnologiesManual.elevatorMotor_Encoder_Data.hasOwnProperty('elevatorMotor_Encoder_Selection')) && (Array.isArray(this.$store.state.driveTechnologiesManual.elevatorMotor_Encoder_Data.elevatorMotor_Encoder_Selection))) {
                        return this.$store.state.driveTechnologiesManual.elevatorMotor_Encoder_Data.elevatorMotor_Encoder_Selection;
                    }
                    else {
                        return [];
                    }

                }
            },
            elevatorMotor_Encoder_Selected: {
                get() {
                    if ((this.$store.state.driveTechnologiesManual.elevatorMotor_Encoder_Data.hasOwnProperty('elevatorMotor_Encoder_Selection')) && (Array.isArray(this.$store.state.driveTechnologiesManual.elevatorMotor_Encoder_Data.elevatorMotor_Encoder_Selection))) {
                        return this.$store.state.driveTechnologiesManual.elevatorMotor_Encoder_Data.elevatorMotor_Encoder_Selection.some(i => i.selected == true)
                    }
                },
            },
            selected_elevatorMotor_Encoder: {
                get() {
                    return this.$store.state.driveTechnologiesManual.elevatorMotor_Encoder_Data.elevatorMotor_Encoder_Selection.find(i => i.selected == true)
                }
            },
            elevatorMotor_Encoder_Selection_Shown: {
                get() {
                    return this.$store.state.driveTechnologiesManual.elevatorMotor_Encoder_Selection_Shown;
                },
                set(value) {
                    this.$store.dispatch('driveTechnologiesManual/change_elevatorMotor_Encoder_Selection_Shown_storeAction', value)
                }
            },

        },
        methods: {
            // elevatorMotor_Brake
            // elevatorMotor_Brake_Voltage
            change_Selected_at_elevatorMotor_Brake_Voltage_Selection(elevatorMotor_Brake_Voltage) {
                if (elevatorMotor_Brake_Voltage.nominalVoltage != this.selected_elevatorMotor_Brake.elevatorMotor_Brake.nominalVoltage) {
                    this.$store.dispatch('driveTechnologiesManual/change_Selected_at_elevatorMotor_Brake_Selection_basedOnChangesTo_elevatorMotor_Brake_Voltage_storeAction', elevatorMotor_Brake_Voltage.nominalVoltage);
                }
            },
            // elevatorMotor_Brake_MechanicalRelease
            change_Selected_at_elevatorMotor_Brake_MechanicalRelease_Selection(elevatorMotor_Brake_MechanicalRelease) {
                if (elevatorMotor_Brake_MechanicalRelease.text != this.selected_elevatorMotor_Brake.elevatorMotor_Brake.mechanicalRelease.text) {
                    this.$store.dispatch('driveTechnologiesManual/change_Selected_at_elevatorMotor_Brake_Selection_basedOnChangesTo_elevatorMotor_Brake_MechanicalRelease_storeAction', elevatorMotor_Brake_MechanicalRelease.text);
                }
            },
            // elevatorMotor_Brake_ReleaseMonitoring
            change_Selected_at_elevatorMotor_Brake_ReleaseMonitoring_Selection(elevatorMotor_Brake_ReleaseMonitoring) {
                if (elevatorMotor_Brake_ReleaseMonitoring.text != this.selected_elevatorMotor_Brake.elevatorMotor_Brake.releaseMonitoring.text) {
                    this.$store.dispatch('driveTechnologiesManual/change_Selected_at_elevatorMotor_Brake_Selection_basedOnChangesTo_elevatorMotor_Brake_ReleaseMonitoring_storeAction', elevatorMotor_Brake_ReleaseMonitoring.text);
                }
            },
            // elevatorMotor_Brake_BrakeConnection_Bowdenwire_rotatedBrakeRelease
            change_Selected_atElementOf_bowdenwireDeliver(value) {
                this.$store.dispatch('driveTechnologiesManual/change_bowdenwireDeliver_configuration_storeAction', value);
            },
            change_Selected_atElementOf_bowdenwireDetails(value) {
                this.$store.dispatch('driveTechnologiesManual/change_bowdenwireDetails_configuration_storeAction', value);
            },
            change_Selected_atElementOf_brakeConnection(value) {
                this.$store.dispatch('driveTechnologiesManual/change_brakeConnection_configuration_storeAction', value);
            },
            change_Selected_atElementOf_rotatedBrakeRelease(value) {
                this.$store.dispatch('driveTechnologiesManual/change_rotatedBrakeRelease_configuration_storeAction', value);
            },

            // elevatorMotor_Encoder
            change_Selected_at_elevatorMotor_Encoder_Selection(elevatorMotor_Encoder) {
                if (elevatorMotor_Encoder.elevatorMotor_Encoder.typeDesignation != this.selected_elevatorMotor_Encoder.elevatorMotor_Encoder.typeDesignation) {
                    const firstIndex_whichMeetCondition = this.elevatorMotor_Encoder_Selection.findIndex(i => i.elevatorMotor_Encoder.typeDesignation == elevatorMotor_Encoder.elevatorMotor_Encoder.typeDesignation);
                    if (firstIndex_whichMeetCondition > -1) {
                        this.$store.dispatch('driveTechnologiesManual/checkIf_changesAt_elevatorMotor_Encoder_changes_configurationFlow_storeAction', firstIndex_whichMeetCondition);
                    }
                    else {
                        // error
                    }
                }
            },
            furtherToCables() {
                this.$store.dispatch('driveTechnologiesManual/checkIf_driveTechnologiesManual_areValid_storeAction');
            },
            furtherToInput() {
                router.push({ params: { slug: 'inputsManual' } })
            },
            furtherToManualHome() {
                this.$store.dispatch('inputsManual/cancelManualMotorConfiguration_storeAction')
            },

        }
    }
</script>


<style>
    .my_elevatorMotor_TemperatureMonitoring {
        list-style: none;
        background-color: #ffffff;
        padding: 0;
        margin: 0;
    }

        .my_elevatorMotor_TemperatureMonitoring li {
            border: 1px solid #ced2d8;
            color: #000000;
            display: inline-block;
            padding: 9px;
            text-align: center;
            margin-bottom: 10px;
        }

            .my_elevatorMotor_TemperatureMonitoring li:nth-child(odd) {
                margin-right: 10px;
                width: calc(50% - 10px);
            }

            .my_elevatorMotor_TemperatureMonitoring li:nth-child(even) {
                margin-left: 10px;
                width: calc(50% - 10px);
            }

        .my_elevatorMotor_TemperatureMonitoring .active {
            border: 2px solid blue;
        }

    .my_elevatorMotor_Brake_Voltage_Selection {
        list-style: none;
        background-color: #ffffff;
        padding: 0;
        margin: 0;
    }

        .my_elevatorMotor_Brake_Voltage_Selection li {
            border: 1px solid #ced2d8;
            color: #000000;
            display: inline-block;
            padding: 9px;
            text-align: center;
            margin-bottom: 10px;
        }

            .my_elevatorMotor_Brake_Voltage_Selection li:nth-child(odd) {
                margin-right: 10px;
                width: calc(50% - 10px);
            }

            .my_elevatorMotor_Brake_Voltage_Selection li:nth-child(even) {
                margin-left: 10px;
                width: calc(50% - 10px);
            }

        .my_elevatorMotor_Brake_Voltage_Selection .active {
            border: 2px solid blue;
        }

    .my_elevatorMotor_Brake_MechanicalRelease_Selection {
        list-style: none;
        background-color: #ffffff;
        padding: 0;
        margin: 0;
    }

        .my_elevatorMotor_Brake_MechanicalRelease_Selection li {
            border: 1px solid #ced2d8;
            color: #000000;
            display: inline-block;
            padding: 9px;
            text-align: center;
            margin-bottom: 10px;
        }

            .my_elevatorMotor_Brake_MechanicalRelease_Selection li:nth-child(odd) {
                margin-right: 10px;
                width: calc(50% - 10px);
            }

            .my_elevatorMotor_Brake_MechanicalRelease_Selection li:nth-child(even) {
                margin-left: 10px;
                width: calc(50% - 10px);
            }

        .my_elevatorMotor_Brake_MechanicalRelease_Selection .active {
            border: 2px solid blue;
        }

        .my_elevatorMotor_Brake_MechanicalRelease_Selection .disabled {
            background-color: #ced2d8;
            pointer-events: none;
        }

    .my_elevatorMotor_Brake_ReleaseMonitoring_Selection {
        list-style: none;
        background-color: #ffffff;
        padding: 0;
        margin: 0;
    }

        .my_elevatorMotor_Brake_ReleaseMonitoring_Selection li {
            border: 1px solid #ced2d8;
            color: #000000;
            display: inline-block;
            padding: 9px;
            text-align: center;
            margin-bottom: 10px;
        }

            .my_elevatorMotor_Brake_ReleaseMonitoring_Selection li:nth-child(odd) {
                margin-right: 10px;
                width: calc(50% - 10px);
            }

            .my_elevatorMotor_Brake_ReleaseMonitoring_Selection li:nth-child(even) {
                margin-left: 10px;
                width: calc(50% - 10px);
            }

        .my_elevatorMotor_Brake_ReleaseMonitoring_Selection .active {
            border: 2px solid blue;
        }

        .my_elevatorMotor_Brake_ReleaseMonitoring_Selection .disabled {
            background-color: #ced2d8;
            pointer-events: none;
        }

    .my_elevatorMotor_Brake_Connection_Selection {
        list-style: none;
        background-color: #ffffff;
        padding: 0;
        margin: 0;
    }

        .my_elevatorMotor_Brake_Connection_Selection li {
            border: 1px solid #ced2d8;
            color: #000000;
            display: inline-block;
            padding: 9px;
            text-align: center;
            margin-bottom: 10px;
        }

            .my_elevatorMotor_Brake_Connection_Selection li:nth-child(odd) {
                margin-right: 10px;
                width: calc(50% - 10px);
            }

            .my_elevatorMotor_Brake_Connection_Selection li:nth-child(even) {
                margin-left: 10px;
                width: calc(50% - 10px);
            }

        .my_elevatorMotor_Brake_Connection_Selection .active {
            border: 2px solid blue;
        }

    .my_elevatorMotor_Brake_Bowdenwire_Selection {
        list-style: none;
        background-color: #ffffff;
        padding: 0;
        margin: 0;
    }

        .my_elevatorMotor_Brake_Bowdenwire_Selection li {
            border: 1px solid #ced2d8;
            color: #000000;
            display: inline-block;
            padding: 9px;
            text-align: center;
            margin-bottom: 10px;
        }

            .my_elevatorMotor_Brake_Bowdenwire_Selection li:nth-child(odd) {
                margin-right: 10px;
                width: calc(50% - 10px);
            }

            .my_elevatorMotor_Brake_Bowdenwire_Selection li:nth-child(even) {
                margin-left: 10px;
                width: calc(50% - 10px);
            }

        .my_elevatorMotor_Brake_Bowdenwire_Selection .active {
            border: 2px solid blue;
        }

    .my_elevatorMotor_Encoder {
        list-style: none;
        background-color: #ffffff;
        padding: 0;
        margin: 0;
    }

        .my_elevatorMotor_Encoder li {
            border: 1px solid #ced2d8;
            color: #000000;
            display: inline-block;
            padding: 9px;
            text-align: center;
            margin-bottom: 10px;
        }

            .my_elevatorMotor_Encoder li:nth-child(odd) {
                margin-right: 10px;
                width: calc(50% - 10px);
            }

            .my_elevatorMotor_Encoder li:nth-child(even) {
                margin-left: 10px;
                width: calc(50% - 10px);
            }

        .my_elevatorMotor_Encoder .active {
            border: 2px solid blue;
        }

    .my_elevatorMotor_Machine_filter {
        list-style: none;
        background-color: #ffffff;
        padding: 0;
        margin: 0;
    }

        .my_elevatorMotor_Machine_filter li {
            border: 2px solid #00338e;
            color: #00338e;
            display: inline-block;
            padding: 9px;
            width: 50%;
            text-align: center;
            font-weight: 600;
        }

        .my_elevatorMotor_Machine_filter .active {
            background-color: #00338e;
            color: #ffffff;
        }


    #my_engine_table_images_ZAproducts {
        height: 70px !important;
    }

    #my_engine_variables {
        margin-top: 15px;
    }

    #my_engine_table_parameters_slash {
        font-size: 1.0rem;
    }

    .my_table_parameters_infoText {
        font-size: 0.9rem;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: inline-block;
        width: calc(100%);
    }

        .my_table_parameters_infoText:hover {
            text-overflow: clip;
            white-space: normal;
            word-break: break-word;
        }
</style>